import React, { useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Input,
  notification,
  Row,
  // Space,
  Typography,
} from "antd";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import VehicleServices from "../../../services/vehicle.services";
// import "../TicketScan.scss";
const PosVehiclePassScan = ({ router }) => {
  const [loading, setLoading] = useState(false);
  const [ticketId, setTicketId] = useState();
  const [data, setData] = useState();
  const [valid, setValid] = useState(false);
  const [errMessage, setErrMessage] = useState();

  const ticketScan = async () => {
    setValid(false);
    setErrMessage(undefined);
    setLoading(true);
    if (!ticketId) {
      notification.error({ message: "Enter Walker Tag ID!" });
    }

    try {
      const reponse = await VehicleServices.scanVehiclePass(ticketId);
      if (reponse) {
        setData(reponse);
      }
      setTicketId("");
      if (!reponse?.success) {
        setErrMessage(reponse?.message);
      }
      setValid(reponse?.success);
      setLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        setValid(false);
        setErrMessage(error?.response?.data?.message);
      }
      setTicketId("");
      catchErrorFunction(error, "Token expired!! Login again.", router);
      setLoading(false);
    }
  };

  const onChangeTicketId = (e) => {
    setTicketId(e.target.value);
    setValid(false);
    setErrMessage(undefined);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      ticketScan();
    }
  };

  return (
    <>
      <Row justify="center">
        <Typography.Title> Vehicle Scan </Typography.Title>
      </Row>
      <Row justify="center">
        <Col
          className="mobile-responsive-width"
          style={{ margin: "8px", textAlign: "left" }}
        >
          {" "}
          Pass Id:{" "}
        </Col>
        <Col className="mobile-responsive-width" style={{ margin: "8px" }}>
          <Input
            maxLength={220}
            value={ticketId}
            onChange={onChangeTicketId}
            onKeyDown={onKeyDown}
            className="mobile-responsive-width"
          />
        </Col>
        <Col className="mobile-responsive-width" style={{ margin: "8px" }}>
          <Button
            className="mobile-responsive-width"
            type="primary"
            onClick={ticketScan}
            loading={loading}
          >
            GO!
          </Button>
        </Col>
      </Row>
      <Row justify="center" style={{ margin: "20px" }}>
        {valid && data && (
          <Alert
            message={`Tag Scanned ${data?.[0]?.ticketId ?? ""}`}
            description={`Tag has been scanned successfully.`}
            type="success"
            showIcon
          />
        )}
        {!valid && errMessage && (
          <Alert
            style={{
              paddingRight: "30px",
              backgroundColor: "red",
              color: "white",
              height: "150px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
              padding: "25px",
            }}
            message={
              <span
                style={{
                  color: "white",
                  fontSize: "30px",
                }}
              >
                Error Scanning Ticket {data?.[0]?.ticketId ?? ""}
              </span>
            }
            description={errMessage}
            type="error"
          />
        )}
      </Row>
      {valid && data && (
        <Row
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xsl={12}
          style={{
            justifyContent: "center",
            margin: "auto",
          }}
        >
          <Card
            hoverable={"true"}
            style={{ width: "100%", textAlign: "left" }}
            title="Pass Details"
          >
            <Row style={{ marginBottom: "5px" }}>
              <Col className="ticket_label">Vehicle No :</Col>
              <Col className="ticket_data">{data?.data?.vehicleNo}</Col>
            </Row>
            <Row style={{ marginBottom: "5px" }}>
              <Col className="ticket_label">Access Gate :</Col>
              <Col className="ticket_data">{data?.data?.accessGate?.name}</Col>
            </Row>
            <Row style={{ marginBottom: "5px" }}>
              <Col className="ticket_label">Department :</Col>
              <Col className="ticket_data">
                {data?.data?.department?.departmentName}
              </Col>
            </Row>
          </Card>
        </Row>
      )}
    </>
  );
};

export default withRouter(PosVehiclePassScan);
